import { withAuthenticationRequired} from '@auth0/auth0-react';
import Header from '../components/Header/Header';
import TabMenu from '../components/TabMenu/TabMenu';
import React from 'react';
import {Loader} from "semantic-ui-react";

export const ProtectedRoute = ({ component }) => {

    const WrappedComponent = withAuthenticationRequired(component, {
        onRedirecting: () => <Loader active indeterminate size='small' />
    });

    return (
        <>
            <Header />
            <TabMenu />
            <WrappedComponent />
        </>
    );
};